
import React, { useEffect, useState } from 'react';
import { cmsDetailsAction } from '../../../features/webCommonSlice';
import moment from 'moment';
import CmsPageShimmer from '../CmsPageShimmer/CmsPageShimmer';

const PrivacyPolicy = () => {
    const [loader, setLoader] = useState(false)
    const [cmsDetails, setCmsDetails] = useState({});

    useEffect(() => {
        setLoader(true)
        cmsDetailsAction({ slug: "privacy-policy" }, (response) => {
            if (response?.status === true) {
                setCmsDetails(response?.data)
            }
            setLoader(false)
        })();
    }, [cmsDetailsAction])

    return (
        <>
            <div className='cms_landing_page'>
                <div className='banner'>
                    Privacy Policy
                    {/* {cmsDetails.title} */}
                    {/* {cmsDetails?.updatedAt ? moment(cmsDetails.updatedAt).format("YYYY-MM-DD") : "-"} */}
                </div>
                <div className='container'>
                    {/* {!loader ?
                        <div className='cms_content_text'>
                            <div dangerouslySetInnerHTML={{ __html: cmsDetails.description }}></div>
                        </div>
                        :
                        <>
                            <CmsPageShimmer />
                        </>
                    } */}

                    <div className="cms_content_text">
                        <p>
                            At Millionaire11, we take your privacy seriously. As a fantasy sports platform owned and operated by Millionaire11 Fantasy Sports Private Limited, we are committed to protecting your personal data with the utmost care and in full compliance with the Information Technology Act, 2000, and other applicable laws of India. By accessing or using the Millionaire11 app or website, you expressly consent to the collection, storage, usage, transfer, processing, and disclosure of your personal and sensitive data in accordance with this Privacy Policy.
                        </p>

                        <br />

                        <p>
                            When you register on our platform, we collect and store personally identifiable information, including but not limited to your name, email address, mobile number, gender, state of residence, and date of birth, which is essential to verifying your identity, confirming your legal eligibility to participate in skill-based fantasy sports contests, and ensuring fair gameplay. Additionally, we may require your PAN card number, Aadhaar card, Voter ID, or Driving License to comply with KYC (Know Your Customer) norms for secure withdrawals and transactions. We may also collect non-personal information such as device identifiers, IP address, mobile network data, location access, browser type, and OS version to enhance the security of our services and optimize your in-app experience.
                        </p>

                        <br />

                        <p>
                            Sensitive information like financial data (e.g., UPI details, bank account numbers, or payment card credentials) is processed only by trusted third-party payment gateways, and Millionaire11 does not store any sensitive financial data on its servers beyond what is necessary to fulfill regulatory and tax-related obligations. We maintain bank-level encryption, secure firewalls, and strict access controls to safeguard user data. In the event of any data breach, we follow the due legal process, notify the concerned authorities, and take immediate corrective actions.
                        </p>

                        <br />

                        <p>
                            We use your information to enable you to participate in fantasy cricket contests, verify eligibility, process winnings, customize your experience, detect fraud, maintain account integrity, and inform you about promotions and updates via SMS, email, push notifications, or calls. We may also use the data for analytical purposes to understand user behavior and improve our platform. 
                        </p>

                        <br />

                        <p>
                            We never sell your personal data. However, data may be shared with authorized third-party service providers such as payment processors, analytics platforms, verification partners, and affiliate marketers, strictly for the purpose of delivering our services, all under stringent confidentiality obligations. Your data may be transferred and stored on servers located outside India in compliance with applicable laws.
                        </p>

                        <br />

                        <p>
                            You have the right to access, correct, or request deletion of your data by contacting our support. Upon account closure, we will anonymize or delete your personal data within 30 days, except when legally required for audit, tax, or fraud-prevention purposes. Cookies and similar tracking tools are used to personalize your experience; you may disable them in your browser, but certain features may not work as intended.
                        </p>

                        <br />

                        <p>
                            We reserve the right to modify this policy at any time. Continued use of the platform constitutes your agreement to the updated policy. Any disputes related to privacy are subject to the exclusive jurisdiction of Indian courts and will be resolved in accordance with the laws of India.
                        </p>

                        <br />

                        <p>
                            ll be resolved in accordance with the laws of India. If you have questions or grievances regarding data privacy, you may contact our designated Grievance Officer via the Help & Support section on our website.
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PrivacyPolicy